import { useNavigate, useParams } from 'react-router'

import { Button } from '@/components/ui/button'
import useTranslator from '@/hooks/translation'
import { useUserQuery } from '@/hooks/user/use-user-query'

export const CompanyNewMemberAction = () => {
  const { data: user } = useUserQuery()
  const navigate = useNavigate()
  const params = useParams()
  const { getTranslation } = useTranslator()

  if (!user.is_admin && !user.is_root) {
    return null
  }

  const handleClick = () => {
    const companyId = params.companyId!
    navigate(`/companies/${companyId}/members/add`)
  }

  return (
    <Button variant="fintalk" size="sm" onClick={handleClick}>
      {getTranslation('members.newMember')}
    </Button>
  )
}
